import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "api/BytePro";
const sub = "Loan";

class LoanService {
  get(fileDataId) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/${fileDataId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  update(loan, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/${fileDataId}`,
        loan,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new LoanService();
